import React, { Component } from 'react'
import { Table, Select, Button, Modal, Tag } from 'antd'
import './CharacterMappingTable.scss'
import { ImagePreview } from '../../../../../../components'

const { Option } = Select

class CharacterMappingTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isManageModalVisible: false
    }
  }

  isCharacterMapped = character => {
    return this.props.changedCharacters.some(char => {
      return char.original.indexOf(character) !== -1
    })
  }

  getMappedCharacterName = character => {
    const charMapping = this.props.changedCharacters.find(char => {
      return char.original.indexOf(character) !== -1
    })
    if (charMapping) {
      return charMapping.current.replace(/^_{2}(.+)_{2}$/, '$1')
    }
    return character.replace(/^_{2}(.+)_{2}$/, '$1')
  }

  handleCharChange = (originalChar, newValue) => {
    const origChar = originalChar.replace(/^_{2}(.+)_{2}$/, '$1')
    const firstChar = this.isCharacterMapped(originalChar) ? null : undefined
    this.props.onCharacterChange(origChar, newValue, firstChar)
  }

  showManageModal = () => {
    this.setState({ isManageModalVisible: true })
  }

  hideManageModal = () => {
    this.setState({ isManageModalVisible: false })
  }

  renderCharacterOption = (char, index) => {
    const attributes = char.attributes || {}
    const prompt = attributes.original_prompt || ''
    const pic = attributes.profile_pic || ''
    const apparels = (attributes.character_apparel || '').replace(
      /[\[\]']/g,
      ''
    )
    const imageBaseUrl = 'https://video-generate.sharelookapp.link/'

    return (
      <Option key={index} value={char.name}>
        <div className="character-option">
          <img
            src={imageBaseUrl + pic}
            alt={char.name}
            className="character-avatar"
            onError={e => {
              e.target.style.display = 'none'
            }}
          />
          <div className="character-info">
            <div className="character-name">
              {char.name} <Tag>{char.gender.toUpperCase()}</Tag>{' '}
            </div>
            {prompt && (
              <div className="character-prompt">
                {prompt.length > 40 ? prompt.slice(0, 40) + '...' : prompt}
              </div>
            )}
            {apparels && <div className="character-apparel">{apparels}</div>}
          </div>
        </div>
      </Option>
    )
  }

  renderCharacterCard = (char, index) => {
    const attributes = char.attributes || {}
    const prompt = attributes.original_prompt || ''
    const pic = attributes.profile_pic || ''
    const apparels = (attributes.character_apparel || '').replace(
      /[\[\]']/g,
      ''
    )
    const gender = char.gender
    const imageBaseUrl = 'https://video-generate.sharelookapp.link/'

    return (
      <div key={index} className="character-card">
        <div className="character-card-header">
          <ImagePreview
            src={imageBaseUrl + pic}
            alt={char.name}
            className="character-card-avatar"
            onError={e => {
              e.target.src =
                'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNmMGYwZjAiLz4KPHR4dCB4PSIyNCIgeT0iMjgiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxMiIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSI+Tk8gSU1HPC90ZXh0Pgo8L3N2Zz4K'
            }}
          />
          <div className="character-card-name">
            <h4>{char.name}</h4>
            <Tag>{gender.toUpperCase()}</Tag>
          </div>
        </div>

        {prompt && (
          <div className="character-card-section">
            <div className="character-card-label">Description:</div>
            <div className="character-card-content">{prompt}</div>
          </div>
        )}

        {apparels && (
          <div className="character-card-section">
            <div className="character-card-label">Apparel:</div>
            <div className="character-card-content">{apparels}</div>
          </div>
        )}
      </div>
    )
  }

  render() {
    const {
      placeholderCharacters,
      characters,
      isFetchingCharacters,
      onAddCharacter
    } = this.props
    const { isManageModalVisible } = this.state

    const columns = [
      {
        title: 'Original Character',
        dataIndex: 'original',
        key: 'original',
        render: text => (
          <span className="original-character">
            {text.replace(/^_{2}(.+)_{2}$/, '$1')}
          </span>
        )
      },
      {
        title: 'Map To',
        dataIndex: 'original',
        key: 'mapTo',
        render: text => (
          <Select
            className="character-select"
            placeholder="Select character to map"
            value={this.getMappedCharacterName(text)}
            onChange={value => this.handleCharChange(text, value)}
            loading={isFetchingCharacters}
            showSearch
            filterOption={(input, option) => {
              return (
                option.props.children.props.children[1].props.children[0].props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              )
            }}
          >
            {characters.map(this.renderCharacterOption)}
          </Select>
        )
      },
      {
        title: 'Status',
        dataIndex: 'original',
        key: 'status',
        render: text => {
          const mapped = this.isCharacterMapped(text)
          return (
            <span
              className={`status-badge ${mapped ? 'mapped' : 'not-mapped'}`}
            >
              {mapped ? '✓ Mapped' : '○ Not Mapped'}
            </span>
          )
        }
      }
    ]

    const dataSource = placeholderCharacters.map((char, index) => ({
      key: index,
      original: char
    }))

    return (
      <div className="character-mapping-container">
        {/* Header */}
        <div className="character-mapping-header">
          <div className="header-content">
            <h3 className="header-title">Character Mapping</h3>
            <p className="header-description">
              Map placeholder characters to your available characters
            </p>
          </div>
          <Button
            type="primary"
            onClick={this.showManageModal}
            className="manage-characters-btn"
          >
            <span className="btn-icon">⚙️</span>
            Manage Characters
          </Button>
        </div>

        {/* Main table */}
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          size="middle"
          className="character-mapping-table"
        />

        {/* Character Management Modal */}
        <Modal
          title={
            <div className="modal-title">
              <span className="modal-icon">👥</span>
              <span>Manage Characters</span>
            </div>
          }
          visible={isManageModalVisible}
          onCancel={this.hideManageModal}
          width={800}
          footer={[
            <Button key="close" onClick={this.hideManageModal}>
              Close
            </Button>
          ]}
          className="character-manage-modal"
        >
          <div className="modal-content">
            {/* Add Character Section */}
            <div className="add-character-section">
              <Button
                type="primary"
                size="large"
                onClick={onAddCharacter}
                className="add-character-btn"
              >
                <span className="btn-icon">+</span>
                Add New Character
              </Button>
              <p className="add-character-description">
                Create a new character to use in your mappings
              </p>
            </div>

            {/* Characters Grid */}
            <div className="characters-grid">
              {characters.map(this.renderCharacterCard)}
            </div>

            {characters.length === 0 && (
              <div className="empty-state">
                <div className="empty-icon">👤</div>
                <p className="empty-title">No characters available yet</p>
                <p className="empty-description">
                  Click "Add New Character" to get started
                </p>
              </div>
            )}
          </div>
        </Modal>
      </div>
    )
  }
}

export default CharacterMappingTable
